import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const BoxTwo = () => {
    return (
        <div className="App">
            <div className="App-body">
                <h1>Box Two - Location: Breakout Room 2</h1>
                <p>
                    Having correctly identified Breakout Room 2, you enter it. 
                    The room bears traces of hastily erased whiteboards and scattered chairs, suggesting secretive and 
                    urgent discussions were recently held here. Scattered across the room are various articles and magazine covers. 
                    At first glance, they seem randomly placed, but a closer look reveals that each piece might hold more 
                    significance than initially meets the eye, subtly influencing the atmosphere and possibly hiding clues 
                    within their headlines and images.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='PuzzleThree'>Go to Puzzle Three</Button>
            </div>
        </div>
    );
  };
  
export default BoxTwo;